import React from "react"
import CalculatorHeroSection from "./CalculatorHeroSection"
import CalculatorForm from "./CalculatorForm"
import CalculatorSection from "./CalculatorSection"
import Structure from "./Structure"
import ProgressPanel from "./ProgressPanel"
import ResultsPanel from "./ResultsPanel"
import OnIOSPromptToInstallPWA from "../../OnIOSPromptToInstallPWA"

interface iOnChange_CalculatorForm {
  data: any
  recentUpdate: { key: string; value: any }
}

export default class CalculatorPage extends React.Component {
  fromCalculatorStructure = {
    makeInitData: (calcStructure: typeof Structure) => {
      return Object.assign(
        {},
        ...Object.keys(calcStructure).map((item: any) => ({ [item]: "" }))
      )
    },
    makeLocalData: (calcStructure: typeof Structure) => {
      return Object.assign(
        {},
        ...Object.keys(calcStructure).map((item: any) => ({
          [item]: {
            value: "",
            error: null,
            warning: null,
          },
        }))
      )
    },
  }

  state = {
    readyToReset: false,
    dataState: this.fromCalculatorStructure.makeLocalData(Structure),
    initData: this.fromCalculatorStructure.makeInitData(Structure),
  } as any

  onClickReset = () => {
    this.setState({
      readyToReset: false,
      initData: this.fromCalculatorStructure.makeInitData(Structure),
      dataState: this.fromCalculatorStructure.makeLocalData(Structure),
    })
  }

  calculatorForm = {
    onSubmit: () => {},
    onChange: (data: iOnChange_CalculatorForm) => {
      if (!this.state.readyToReset)
        this.setState({
          readyToReset: true,
        })
      const { key, value } = data.recentUpdate
      const errorFunc = Structure[key].error
      const warningFunc = Structure[key].warning
      let error = null
      let warning = null
      if (errorFunc) error = errorFunc(value) || null
      else if (warningFunc) warning = warningFunc(value) || null
      this.setState({
        dataState: {
          ...this.state.dataState,
          [key]: { value, error, warning },
        },
      })
    },
  }

  render = () => (
    <>
      <CalculatorHeroSection
        onClick={this.onClickReset}
        readyToReset={this.state.readyToReset}
      />
      <OnIOSPromptToInstallPWA />
      <CalculatorSection
        CalculatorForm={
          <CalculatorForm
            initData={this.state.initData}
            onSubmit={this.calculatorForm.onSubmit}
            calculatorStructure={Structure}
            onChange={this.calculatorForm.onChange}
          />
        }
        ProgressPanel={
          <ProgressPanel
            data={this.state.dataState}
            calculatorStructure={Structure}
          />
        }
      />

      <ResultsPanel
        data={this.state.dataState}
        calculatorStructure={Structure}
      />
    </>
  )
}
